import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=39645800&scoped=true"
import script from "./Headers.vue?vue&type=script&lang=js"
export * from "./Headers.vue?vue&type=script&lang=js"
import style0 from "./Headers.vue?vue&type=style&index=0&id=39645800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39645800",
  null
  
)

export default component.exports